export default "__VITE_ASSET__CoGmOHqT__"